/**
 * Ajax 待機用モーダル（globalAjaxWaitModal）。{@see resources/views/share/dialogs.blade.php}
 * backdrop なしで表示し、画面全体をブロックしない（Bootstrap Modal option + data 属性）。
 * 複数同時リクエストは参照カウントで 1 枚のモーダルを共有する。
 */
let jpenergyAjaxWaitModalOpenDepth = 0;

window.jpenergyShowAjaxWaitModal = function () {
    const modalEl = document.getElementById('globalAjaxWaitModal');
    if (!modalEl) {
        return;
    }
    modalEl.classList.remove('fade');
    jpenergyAjaxWaitModalOpenDepth += 1;
    if (jpenergyAjaxWaitModalOpenDepth > 1) {
        return;
    }
    const modal = bootstrap.Modal.getOrCreateInstance(modalEl, {
        backdrop: false,
        keyboard: false,
        focus: true,
    });
    modal.show();
};

window.jpenergyHideAjaxWaitModal = function () {
    const modalEl = document.getElementById('globalAjaxWaitModal');
    if (!modalEl) {
        return;
    }
    jpenergyAjaxWaitModalOpenDepth = Math.max(0, jpenergyAjaxWaitModalOpenDepth - 1);
    if (jpenergyAjaxWaitModalOpenDepth > 0) {
        return;
    }
    const modal = bootstrap.Modal.getInstance(modalEl);
    if (modal) {
        modal.hide();
    }
};
